import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    socialPostsAdminControllerCreateSocialPostV1: build.mutation<
      SocialPostsAdminControllerCreateSocialPostV1ApiResponse,
      SocialPostsAdminControllerCreateSocialPostV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts`,
        method: 'POST',
        body: queryArg.createSocialPostBody,
      }),
    }),
    socialPostsAdminControllerListSocialPostsV1: build.query<
      SocialPostsAdminControllerListSocialPostsV1ApiResponse,
      SocialPostsAdminControllerListSocialPostsV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts`,
        params: {
          status: queryArg.status,
        },
      }),
    }),
    socialPostsAdminControllerGetSocialPostV1: build.query<
      SocialPostsAdminControllerGetSocialPostV1ApiResponse,
      SocialPostsAdminControllerGetSocialPostV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}`,
      }),
    }),
    socialPostsAdminControllerUpdateSocialPostV1: build.mutation<
      SocialPostsAdminControllerUpdateSocialPostV1ApiResponse,
      SocialPostsAdminControllerUpdateSocialPostV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateSocialPostBody,
      }),
    }),
    socialPostsAdminControllerDeleteSocialPostV1: build.mutation<
      SocialPostsAdminControllerDeleteSocialPostV1ApiResponse,
      SocialPostsAdminControllerDeleteSocialPostV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    socialPostsAdminControllerRegenerateSocialPostV1: build.mutation<
      SocialPostsAdminControllerRegenerateSocialPostV1ApiResponse,
      SocialPostsAdminControllerRegenerateSocialPostV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}/regenerate`,
        method: 'POST',
        body: queryArg.regenerateSocialPostBody,
      }),
    }),
    socialPostsAdminControllerApproveSocialPostV1: build.mutation<
      SocialPostsAdminControllerApproveSocialPostV1ApiResponse,
      SocialPostsAdminControllerApproveSocialPostV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}/approve`,
        method: 'POST',
        body: queryArg.approveSocialPostBody,
      }),
    }),
    socialPostsAdminControllerUnscheduleSocialPostV1: build.mutation<
      SocialPostsAdminControllerUnscheduleSocialPostV1ApiResponse,
      SocialPostsAdminControllerUnscheduleSocialPostV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}/unschedule`,
        method: 'POST',
      }),
    }),
    socialPostsAdminControllerCancelSocialPostV1: build.mutation<
      SocialPostsAdminControllerCancelSocialPostV1ApiResponse,
      SocialPostsAdminControllerCancelSocialPostV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}/cancel`,
        method: 'POST',
      }),
    }),
    socialPostsAdminControllerRedraftSocialPostV1: build.mutation<
      SocialPostsAdminControllerRedraftSocialPostV1ApiResponse,
      SocialPostsAdminControllerRedraftSocialPostV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}/redraft`,
        method: 'POST',
      }),
    }),
    socialPostsAdminControllerUnpublishSocialPostV1: build.mutation<
      SocialPostsAdminControllerUnpublishSocialPostV1ApiResponse,
      SocialPostsAdminControllerUnpublishSocialPostV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}/unpublish`,
        method: 'POST',
        params: {
          removedByHand: queryArg.removedByHand,
        },
      }),
    }),
    socialPostsAdminControllerPresignSocialPostMediaV1: build.mutation<
      SocialPostsAdminControllerPresignSocialPostMediaV1ApiResponse,
      SocialPostsAdminControllerPresignSocialPostMediaV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}/media/presign`,
        method: 'POST',
        body: queryArg.presignSocialPostMediaBody,
      }),
    }),
    socialPostsAdminControllerRegisterSocialPostMediaV1: build.mutation<
      SocialPostsAdminControllerRegisterSocialPostMediaV1ApiResponse,
      SocialPostsAdminControllerRegisterSocialPostMediaV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}/media`,
        method: 'POST',
        body: queryArg.registerSocialPostMediaBody,
      }),
    }),
    socialPostsAdminControllerRemoveSocialPostMediaV1: build.mutation<
      SocialPostsAdminControllerRemoveSocialPostMediaV1ApiResponse,
      SocialPostsAdminControllerRemoveSocialPostMediaV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/social-posts/${queryArg.id}/media/${queryArg.mediaId}`,
        method: 'DELETE',
      }),
    }),
    socialAccountsAdminControllerListSocialAccountsV1: build.query<
      SocialAccountsAdminControllerListSocialAccountsV1ApiResponse,
      SocialAccountsAdminControllerListSocialAccountsV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/social-accounts` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type SocialPostsAdminControllerCreateSocialPostV1ApiResponse =
  /** status 201 The new draft */ CreateSocialPostResponse;
export type SocialPostsAdminControllerCreateSocialPostV1ApiArg = {
  createSocialPostBody: CreateSocialPostBody;
};
export type SocialPostsAdminControllerListSocialPostsV1ApiResponse =
  /** status 200 Social posts */ ListSocialPostsResponse;
export type SocialPostsAdminControllerListSocialPostsV1ApiArg = {
  /** DRAFT → SCHEDULED → PUBLISHING → PUBLISHED | PARTIAL | FAILED; SCHEDULED → CANCELLED; SCHEDULED → DRAFT (unschedule); FAILED → DRAFT (redraft); PUBLISHED/PARTIAL → UNPUBLISHED (unpublish: taken down from every network). assistant-smm owns the whole lifecycle; Zernio only publishes. */
  status?:
    | 'DRAFT'
    | 'SCHEDULED'
    | 'PUBLISHING'
    | 'PUBLISHED'
    | 'PARTIAL'
    | 'FAILED'
    | 'CANCELLED'
    | 'UNPUBLISHED';
};
export type SocialPostsAdminControllerGetSocialPostV1ApiResponse =
  /** status 200 The post */ GetSocialPostResponse;
export type SocialPostsAdminControllerGetSocialPostV1ApiArg = {
  id: number;
};
export type SocialPostsAdminControllerUpdateSocialPostV1ApiResponse =
  /** status 200 The updated draft */ UpdateSocialPostResponse;
export type SocialPostsAdminControllerUpdateSocialPostV1ApiArg = {
  id: number;
  updateSocialPostBody: UpdateSocialPostBody;
};
export type SocialPostsAdminControllerDeleteSocialPostV1ApiResponse = unknown;
export type SocialPostsAdminControllerDeleteSocialPostV1ApiArg = {
  id: number;
};
export type SocialPostsAdminControllerRegenerateSocialPostV1ApiResponse =
  /** status 200 The draft with new variants */ RegenerateSocialPostResponse;
export type SocialPostsAdminControllerRegenerateSocialPostV1ApiArg = {
  id: number;
  regenerateSocialPostBody: RegenerateSocialPostBody;
};
export type SocialPostsAdminControllerApproveSocialPostV1ApiResponse =
  /** status 200 The SCHEDULED post, or for publishNow the published result: PUBLISHED, PARTIAL, or FAILED (a permanent rejection is a 200 with status FAILED and failureReason). Rarely PUBLISHING, when Zernio has not finished yet: the publisher settles it within minutes, or fails it after the grace period; read the post again */ ApproveSocialPostResponse;
export type SocialPostsAdminControllerApproveSocialPostV1ApiArg = {
  id: number;
  approveSocialPostBody: ApproveSocialPostBody;
};
export type SocialPostsAdminControllerUnscheduleSocialPostV1ApiResponse =
  /** status 200 The post, back to DRAFT */ UnscheduleSocialPostResponse;
export type SocialPostsAdminControllerUnscheduleSocialPostV1ApiArg = {
  id: number;
};
export type SocialPostsAdminControllerCancelSocialPostV1ApiResponse = unknown;
export type SocialPostsAdminControllerCancelSocialPostV1ApiArg = {
  id: number;
};
export type SocialPostsAdminControllerRedraftSocialPostV1ApiResponse =
  /** status 200 The post, back to DRAFT */ RedraftSocialPostResponse;
export type SocialPostsAdminControllerRedraftSocialPostV1ApiArg = {
  id: number;
};
export type SocialPostsAdminControllerUnpublishSocialPostV1ApiResponse =
  /** status 200 The post, UNPUBLISHED */ UnpublishSocialPostResponse;
export type SocialPostsAdminControllerUnpublishSocialPostV1ApiArg = {
  id: number;
  /** The manager has deleted, on the network itself, the copies Zernio cannot take down: those on a network it cannot unpublish from, and any whose earlier attempt failed (it still carries an error) and that Zernio refuses again with a 4xx (e.g. a disconnected account) without confirming the copy is gone. A copy failing for the first time answers 503 first. They are marked DELETED instead of refusing (400) or answering 503. A call that fails transiently this time (network, our API key refused, timeout, 429, 5xx) still answers 503, whatever the earlier error was. Zernio still takes down every copy it can first. */
  removedByHand?: boolean;
};
export type SocialPostsAdminControllerPresignSocialPostMediaV1ApiResponse =
  /** status 200 The presigned upload */ PresignSocialPostMediaResponse;
export type SocialPostsAdminControllerPresignSocialPostMediaV1ApiArg = {
  id: number;
  presignSocialPostMediaBody: PresignSocialPostMediaBody;
};
export type SocialPostsAdminControllerRegisterSocialPostMediaV1ApiResponse =
  /** status 201 The attached media */ RegisterSocialPostMediaResponse;
export type SocialPostsAdminControllerRegisterSocialPostMediaV1ApiArg = {
  id: number;
  registerSocialPostMediaBody: RegisterSocialPostMediaBody;
};
export type SocialPostsAdminControllerRemoveSocialPostMediaV1ApiResponse = unknown;
export type SocialPostsAdminControllerRemoveSocialPostMediaV1ApiArg = {
  id: number;
  mediaId: number;
};
export type SocialAccountsAdminControllerListSocialAccountsV1ApiResponse =
  /** status 200 Connected accounts */ ListSocialAccountsResponse;
export type SocialAccountsAdminControllerListSocialAccountsV1ApiArg = void;
export type CreateSocialPostResponse = {
  /** Social post id */
  id: number;
  /** The author's draft, as written */
  originalText: string;
  /** DRAFT → SCHEDULED → PUBLISHING → PUBLISHED | PARTIAL | FAILED; SCHEDULED → CANCELLED; SCHEDULED → DRAFT (unschedule); FAILED → DRAFT (redraft); PUBLISHED/PARTIAL → UNPUBLISHED (unpublish: taken down from every network). assistant-smm owns the whole lifecycle; Zernio only publishes. */
  status:
    | 'DRAFT'
    | 'SCHEDULED'
    | 'PUBLISHING'
    | 'PUBLISHED'
    | 'PARTIAL'
    | 'FAILED'
    | 'CANCELLED'
    | 'UNPUBLISHED';
  /** When the post publishes (UTC) */
  scheduledFor: null | string;
  /** IANA zone the time was chosen in */
  timezone: null | string;
  /** scheduledFor as wall-clock time in timezone (YYYY-MM-DDTHH:mm:ss) */
  scheduledAt: null | string;
  /** Zernio post id once published */
  zernioPostId: null | string;
  /** When it was published */
  publishedAt: null | string;
  /** Why the post failed or partially failed */
  failureReason: null | string;
  /** The text per profile the targets need: twitter for X, default for every other network */
  variants: {
    /** Text profile: twitter is published to X only; default to every other network */
    profile: 'twitter' | 'default';
    /** The targeted networks this text is published to */
    platforms: string[];
    /** The text published to this profile's networks; null when the DeepSeek rewrite failed */
    content: null | string;
    /** content's length as the limit counts it: on X, CJK and emoji count as 2 and every link as 23 */
    length: number;
    /** This profile's text limit */
    maxLength: number;
    /** Model that wrote this variant */
    aiModel: null | string;
    /** Edited by hand after generation */
    edited: boolean;
  }[];
  /** Connected accounts the post publishes to */
  targets: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
    /** Per-account publish status */
    status: 'PENDING' | 'PUBLISHED' | 'FAILED' | 'DELETED';
    /** Live post URL once published */
    publishedUrl: null | string;
    /** Publish error reported by Zernio */
    error: null | string;
  }[];
  /** Attached images */
  media: {
    /** Media id */
    id: number;
    /** Object key in the (private) bucket */
    key: string;
    /** Short-lived signed read link for showing the image; fetch a fresh one by reading the post again */
    previewUrl: string;
    contentType: string;
    sizeBytes: number;
    /** Order on the post */
    position: number;
    /** Registered at */
    createdAt: string;
  }[];
  /** Created at */
  createdAt: string;
  createdBy: number;
  /** Updated at */
  updatedAt: string;
  updatedBy: number;
};
export type BadRequestError = {
  statusCode: number;
  error?: string;
  /** Localized, human-readable */
  message: string;
  /** exceptions.BAD_REQUEST_VALIDATION is a request body or query that fails its schema; `errors` lists the fields. */
  code:
    | 'exceptions.BAD_REQUEST'
    | 'exceptions.BAD_REQUEST_INT_PARAM'
    | 'exceptions.BAD_REQUEST_VALIDATION'
    | 'social-post.exceptions.BAD_REQUEST_REDRAFT_PUBLISHED'
    | 'social-post.exceptions.BAD_REQUEST_UNPUBLISH_UNSUPPORTED'
    | 'social-post.exceptions.BAD_REQUEST_REGENERATE'
    | 'social-post.exceptions.BAD_REQUEST_MEDIA_TYPE'
    | 'social-post.exceptions.BAD_REQUEST_MEDIA_TOO_LARGE'
    | 'social-post.exceptions.BAD_REQUEST_MEDIA_LIMIT'
    | 'social-post.exceptions.BAD_REQUEST_MEDIA_MISSING'
    | 'social-post.exceptions.BAD_REQUEST_MEDIA_MISMATCH'
    | 'social-post.exceptions.BAD_REQUEST_MEDIA_KEY'
    | 'social-post.exceptions.BAD_REQUEST_APPROVE_MEDIA'
    | 'social-post.exceptions.BAD_REQUEST_APPROVE_PAST'
    | 'social-post.exceptions.BAD_REQUEST_APPROVE_TIME'
    | 'social-post.exceptions.BAD_REQUEST_APPROVE_VARIANT'
    | 'social-post.exceptions.BAD_REQUEST_VARIANT_LENGTH'
    | 'social-post.exceptions.BAD_REQUEST_VARIANT_PROFILE';
  /** Text profile: twitter is published to X only; default to every other network */
  profile?: 'twitter' | 'default';
  /** On BAD_REQUEST_VALIDATION: one entry per failed field */
  errors?: {
    path: string;
    message: string;
    [key: string]: any;
  }[];
};
export type ForbiddenError = {
  statusCode: number;
  error?: string;
  /** Localized, human-readable */
  message: string;
  /** FORBIDDEN_RESOURCE(_ID): the Cerbos policy refuses the action, for this role or in this post status */
  code:
    | 'exceptions.FORBIDDEN'
    | 'exceptions.FORBIDDEN_RESOURCE'
    | 'exceptions.FORBIDDEN_RESOURCE_ID'
    | 'social-post.exceptions.FORBIDDEN_CANCEL';
};
export type TooManyRequestsError = {
  statusCode: number;
  error?: string;
  /** Localized, human-readable */
  message: string;
  code: 'exceptions.TOO_MANY_REQUESTS';
};
export type CreateSocialPostBody = {
  /** The author's draft, as written */
  originalText: string;
  /** Connected accounts to publish to */
  targets: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
  }[];
};
export type ListSocialPostsResponse = {
  /** Social post id */
  id: number;
  /** The author's draft, as written */
  originalText: string;
  /** DRAFT → SCHEDULED → PUBLISHING → PUBLISHED | PARTIAL | FAILED; SCHEDULED → CANCELLED; SCHEDULED → DRAFT (unschedule); FAILED → DRAFT (redraft); PUBLISHED/PARTIAL → UNPUBLISHED (unpublish: taken down from every network). assistant-smm owns the whole lifecycle; Zernio only publishes. */
  status:
    | 'DRAFT'
    | 'SCHEDULED'
    | 'PUBLISHING'
    | 'PUBLISHED'
    | 'PARTIAL'
    | 'FAILED'
    | 'CANCELLED'
    | 'UNPUBLISHED';
  /** When the post publishes (UTC) */
  scheduledFor: null | string;
  /** IANA zone the time was chosen in */
  timezone: null | string;
  /** scheduledFor as wall-clock time in timezone (YYYY-MM-DDTHH:mm:ss) */
  scheduledAt: null | string;
  /** Zernio post id once published */
  zernioPostId: null | string;
  /** When it was published */
  publishedAt: null | string;
  /** Why the post failed or partially failed */
  failureReason: null | string;
  /** The text per profile the targets need: twitter for X, default for every other network */
  variants: {
    /** Text profile: twitter is published to X only; default to every other network */
    profile: 'twitter' | 'default';
    /** The targeted networks this text is published to */
    platforms: string[];
    /** The text published to this profile's networks; null when the DeepSeek rewrite failed */
    content: null | string;
    /** content's length as the limit counts it: on X, CJK and emoji count as 2 and every link as 23 */
    length: number;
    /** This profile's text limit */
    maxLength: number;
    /** Model that wrote this variant */
    aiModel: null | string;
    /** Edited by hand after generation */
    edited: boolean;
  }[];
  /** Connected accounts the post publishes to */
  targets: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
    /** Per-account publish status */
    status: 'PENDING' | 'PUBLISHED' | 'FAILED' | 'DELETED';
    /** Live post URL once published */
    publishedUrl: null | string;
    /** Publish error reported by Zernio */
    error: null | string;
  }[];
  /** Attached images */
  media: {
    /** Media id */
    id: number;
    /** Object key in the (private) bucket */
    key: string;
    /** Short-lived signed read link for showing the image; fetch a fresh one by reading the post again */
    previewUrl: string;
    contentType: string;
    sizeBytes: number;
    /** Order on the post */
    position: number;
    /** Registered at */
    createdAt: string;
  }[];
  /** Created at */
  createdAt: string;
  createdBy: number;
  /** Updated at */
  updatedAt: string;
  updatedBy: number;
}[];
export type GetSocialPostResponse = {
  /** Social post id */
  id: number;
  /** The author's draft, as written */
  originalText: string;
  /** DRAFT → SCHEDULED → PUBLISHING → PUBLISHED | PARTIAL | FAILED; SCHEDULED → CANCELLED; SCHEDULED → DRAFT (unschedule); FAILED → DRAFT (redraft); PUBLISHED/PARTIAL → UNPUBLISHED (unpublish: taken down from every network). assistant-smm owns the whole lifecycle; Zernio only publishes. */
  status:
    | 'DRAFT'
    | 'SCHEDULED'
    | 'PUBLISHING'
    | 'PUBLISHED'
    | 'PARTIAL'
    | 'FAILED'
    | 'CANCELLED'
    | 'UNPUBLISHED';
  /** When the post publishes (UTC) */
  scheduledFor: null | string;
  /** IANA zone the time was chosen in */
  timezone: null | string;
  /** scheduledFor as wall-clock time in timezone (YYYY-MM-DDTHH:mm:ss) */
  scheduledAt: null | string;
  /** Zernio post id once published */
  zernioPostId: null | string;
  /** When it was published */
  publishedAt: null | string;
  /** Why the post failed or partially failed */
  failureReason: null | string;
  /** The text per profile the targets need: twitter for X, default for every other network */
  variants: {
    /** Text profile: twitter is published to X only; default to every other network */
    profile: 'twitter' | 'default';
    /** The targeted networks this text is published to */
    platforms: string[];
    /** The text published to this profile's networks; null when the DeepSeek rewrite failed */
    content: null | string;
    /** content's length as the limit counts it: on X, CJK and emoji count as 2 and every link as 23 */
    length: number;
    /** This profile's text limit */
    maxLength: number;
    /** Model that wrote this variant */
    aiModel: null | string;
    /** Edited by hand after generation */
    edited: boolean;
  }[];
  /** Connected accounts the post publishes to */
  targets: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
    /** Per-account publish status */
    status: 'PENDING' | 'PUBLISHED' | 'FAILED' | 'DELETED';
    /** Live post URL once published */
    publishedUrl: null | string;
    /** Publish error reported by Zernio */
    error: null | string;
  }[];
  /** Attached images */
  media: {
    /** Media id */
    id: number;
    /** Object key in the (private) bucket */
    key: string;
    /** Short-lived signed read link for showing the image; fetch a fresh one by reading the post again */
    previewUrl: string;
    contentType: string;
    sizeBytes: number;
    /** Order on the post */
    position: number;
    /** Registered at */
    createdAt: string;
  }[];
  /** Created at */
  createdAt: string;
  createdBy: number;
  /** Updated at */
  updatedAt: string;
  updatedBy: number;
};
export type NotFoundError = {
  statusCode: number;
  error?: string;
  /** Localized, human-readable */
  message: string;
  code:
    | 'exceptions.NOT_FOUND'
    | 'social-post.exceptions.NOT_FOUND'
    | 'social-post.exceptions.MEDIA_NOT_FOUND';
};
export type UpdateSocialPostResponse = {
  /** Social post id */
  id: number;
  /** The author's draft, as written */
  originalText: string;
  /** DRAFT → SCHEDULED → PUBLISHING → PUBLISHED | PARTIAL | FAILED; SCHEDULED → CANCELLED; SCHEDULED → DRAFT (unschedule); FAILED → DRAFT (redraft); PUBLISHED/PARTIAL → UNPUBLISHED (unpublish: taken down from every network). assistant-smm owns the whole lifecycle; Zernio only publishes. */
  status:
    | 'DRAFT'
    | 'SCHEDULED'
    | 'PUBLISHING'
    | 'PUBLISHED'
    | 'PARTIAL'
    | 'FAILED'
    | 'CANCELLED'
    | 'UNPUBLISHED';
  /** When the post publishes (UTC) */
  scheduledFor: null | string;
  /** IANA zone the time was chosen in */
  timezone: null | string;
  /** scheduledFor as wall-clock time in timezone (YYYY-MM-DDTHH:mm:ss) */
  scheduledAt: null | string;
  /** Zernio post id once published */
  zernioPostId: null | string;
  /** When it was published */
  publishedAt: null | string;
  /** Why the post failed or partially failed */
  failureReason: null | string;
  /** The text per profile the targets need: twitter for X, default for every other network */
  variants: {
    /** Text profile: twitter is published to X only; default to every other network */
    profile: 'twitter' | 'default';
    /** The targeted networks this text is published to */
    platforms: string[];
    /** The text published to this profile's networks; null when the DeepSeek rewrite failed */
    content: null | string;
    /** content's length as the limit counts it: on X, CJK and emoji count as 2 and every link as 23 */
    length: number;
    /** This profile's text limit */
    maxLength: number;
    /** Model that wrote this variant */
    aiModel: null | string;
    /** Edited by hand after generation */
    edited: boolean;
  }[];
  /** Connected accounts the post publishes to */
  targets: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
    /** Per-account publish status */
    status: 'PENDING' | 'PUBLISHED' | 'FAILED' | 'DELETED';
    /** Live post URL once published */
    publishedUrl: null | string;
    /** Publish error reported by Zernio */
    error: null | string;
  }[];
  /** Attached images */
  media: {
    /** Media id */
    id: number;
    /** Object key in the (private) bucket */
    key: string;
    /** Short-lived signed read link for showing the image; fetch a fresh one by reading the post again */
    previewUrl: string;
    contentType: string;
    sizeBytes: number;
    /** Order on the post */
    position: number;
    /** Registered at */
    createdAt: string;
  }[];
  /** Created at */
  createdAt: string;
  createdBy: number;
  /** Updated at */
  updatedAt: string;
  updatedBy: number;
};
export type UpdateSocialPostBody = {
  /** The author's draft, as written */
  originalText?: string;
  /** Connected accounts to publish to */
  targets?: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
  }[];
  /** Hand-edited text per profile, one entry each; only profiles the targets need */
  variants?: {
    /** Text profile: twitter is published to X only; default to every other network */
    profile: 'twitter' | 'default';
    content: string;
  }[];
};
export type RegenerateSocialPostResponse = {
  /** Social post id */
  id: number;
  /** The author's draft, as written */
  originalText: string;
  /** DRAFT → SCHEDULED → PUBLISHING → PUBLISHED | PARTIAL | FAILED; SCHEDULED → CANCELLED; SCHEDULED → DRAFT (unschedule); FAILED → DRAFT (redraft); PUBLISHED/PARTIAL → UNPUBLISHED (unpublish: taken down from every network). assistant-smm owns the whole lifecycle; Zernio only publishes. */
  status:
    | 'DRAFT'
    | 'SCHEDULED'
    | 'PUBLISHING'
    | 'PUBLISHED'
    | 'PARTIAL'
    | 'FAILED'
    | 'CANCELLED'
    | 'UNPUBLISHED';
  /** When the post publishes (UTC) */
  scheduledFor: null | string;
  /** IANA zone the time was chosen in */
  timezone: null | string;
  /** scheduledFor as wall-clock time in timezone (YYYY-MM-DDTHH:mm:ss) */
  scheduledAt: null | string;
  /** Zernio post id once published */
  zernioPostId: null | string;
  /** When it was published */
  publishedAt: null | string;
  /** Why the post failed or partially failed */
  failureReason: null | string;
  /** The text per profile the targets need: twitter for X, default for every other network */
  variants: {
    /** Text profile: twitter is published to X only; default to every other network */
    profile: 'twitter' | 'default';
    /** The targeted networks this text is published to */
    platforms: string[];
    /** The text published to this profile's networks; null when the DeepSeek rewrite failed */
    content: null | string;
    /** content's length as the limit counts it: on X, CJK and emoji count as 2 and every link as 23 */
    length: number;
    /** This profile's text limit */
    maxLength: number;
    /** Model that wrote this variant */
    aiModel: null | string;
    /** Edited by hand after generation */
    edited: boolean;
  }[];
  /** Connected accounts the post publishes to */
  targets: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
    /** Per-account publish status */
    status: 'PENDING' | 'PUBLISHED' | 'FAILED' | 'DELETED';
    /** Live post URL once published */
    publishedUrl: null | string;
    /** Publish error reported by Zernio */
    error: null | string;
  }[];
  /** Attached images */
  media: {
    /** Media id */
    id: number;
    /** Object key in the (private) bucket */
    key: string;
    /** Short-lived signed read link for showing the image; fetch a fresh one by reading the post again */
    previewUrl: string;
    contentType: string;
    sizeBytes: number;
    /** Order on the post */
    position: number;
    /** Registered at */
    createdAt: string;
  }[];
  /** Created at */
  createdAt: string;
  createdBy: number;
  /** Updated at */
  updatedAt: string;
  updatedBy: number;
};
export type RegenerateSocialPostBody = {
  profiles?: ('twitter' | 'default')[];
};
export type ApproveSocialPostResponse = {
  /** Social post id */
  id: number;
  /** The author's draft, as written */
  originalText: string;
  /** DRAFT → SCHEDULED → PUBLISHING → PUBLISHED | PARTIAL | FAILED; SCHEDULED → CANCELLED; SCHEDULED → DRAFT (unschedule); FAILED → DRAFT (redraft); PUBLISHED/PARTIAL → UNPUBLISHED (unpublish: taken down from every network). assistant-smm owns the whole lifecycle; Zernio only publishes. */
  status:
    | 'DRAFT'
    | 'SCHEDULED'
    | 'PUBLISHING'
    | 'PUBLISHED'
    | 'PARTIAL'
    | 'FAILED'
    | 'CANCELLED'
    | 'UNPUBLISHED';
  /** When the post publishes (UTC) */
  scheduledFor: null | string;
  /** IANA zone the time was chosen in */
  timezone: null | string;
  /** scheduledFor as wall-clock time in timezone (YYYY-MM-DDTHH:mm:ss) */
  scheduledAt: null | string;
  /** Zernio post id once published */
  zernioPostId: null | string;
  /** When it was published */
  publishedAt: null | string;
  /** Why the post failed or partially failed */
  failureReason: null | string;
  /** The text per profile the targets need: twitter for X, default for every other network */
  variants: {
    /** Text profile: twitter is published to X only; default to every other network */
    profile: 'twitter' | 'default';
    /** The targeted networks this text is published to */
    platforms: string[];
    /** The text published to this profile's networks; null when the DeepSeek rewrite failed */
    content: null | string;
    /** content's length as the limit counts it: on X, CJK and emoji count as 2 and every link as 23 */
    length: number;
    /** This profile's text limit */
    maxLength: number;
    /** Model that wrote this variant */
    aiModel: null | string;
    /** Edited by hand after generation */
    edited: boolean;
  }[];
  /** Connected accounts the post publishes to */
  targets: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
    /** Per-account publish status */
    status: 'PENDING' | 'PUBLISHED' | 'FAILED' | 'DELETED';
    /** Live post URL once published */
    publishedUrl: null | string;
    /** Publish error reported by Zernio */
    error: null | string;
  }[];
  /** Attached images */
  media: {
    /** Media id */
    id: number;
    /** Object key in the (private) bucket */
    key: string;
    /** Short-lived signed read link for showing the image; fetch a fresh one by reading the post again */
    previewUrl: string;
    contentType: string;
    sizeBytes: number;
    /** Order on the post */
    position: number;
    /** Registered at */
    createdAt: string;
  }[];
  /** Created at */
  createdAt: string;
  createdBy: number;
  /** Updated at */
  updatedAt: string;
  updatedBy: number;
};
export type ConflictError = {
  statusCode: number;
  error?: string;
  /** Localized, human-readable */
  message: string;
  /** CONFLICT_MEDIA_REGISTERED: the uploaded key is already attached. CONFLICT_CLAIMED: the post is being published (by the publisher, or another publishNow) */
  code:
    | 'exceptions.CONFLICT'
    | 'social-post.exceptions.CONFLICT_MEDIA_REGISTERED'
    | 'social-post.exceptions.CONFLICT_CLAIMED';
};
export type ServiceUnavailableError = {
  statusCode: number;
  error?: string;
  /** Localized, human-readable */
  message: string;
  code:
    | 'exceptions.SERVICE_UNAVAILABLE'
    | 'social-post.exceptions.SERVICE_UNAVAILABLE_PUBLISH'
    | 'social-post.exceptions.SERVICE_UNAVAILABLE_ACCOUNTS'
    | 'social-post.exceptions.SERVICE_UNAVAILABLE_UNPUBLISH';
};
export type ApproveSocialPostBody =
  | {
      /** Wall-clock date-time in `timezone`, without an offset; must be in the future */
      scheduledAt: string;
      /** IANA time zone */
      timezone: string;
    }
  | {
      /** Publish immediately */
      publishNow: true;
    };
export type UnscheduleSocialPostResponse = {
  /** Social post id */
  id: number;
  /** The author's draft, as written */
  originalText: string;
  /** DRAFT → SCHEDULED → PUBLISHING → PUBLISHED | PARTIAL | FAILED; SCHEDULED → CANCELLED; SCHEDULED → DRAFT (unschedule); FAILED → DRAFT (redraft); PUBLISHED/PARTIAL → UNPUBLISHED (unpublish: taken down from every network). assistant-smm owns the whole lifecycle; Zernio only publishes. */
  status:
    | 'DRAFT'
    | 'SCHEDULED'
    | 'PUBLISHING'
    | 'PUBLISHED'
    | 'PARTIAL'
    | 'FAILED'
    | 'CANCELLED'
    | 'UNPUBLISHED';
  /** When the post publishes (UTC) */
  scheduledFor: null | string;
  /** IANA zone the time was chosen in */
  timezone: null | string;
  /** scheduledFor as wall-clock time in timezone (YYYY-MM-DDTHH:mm:ss) */
  scheduledAt: null | string;
  /** Zernio post id once published */
  zernioPostId: null | string;
  /** When it was published */
  publishedAt: null | string;
  /** Why the post failed or partially failed */
  failureReason: null | string;
  /** The text per profile the targets need: twitter for X, default for every other network */
  variants: {
    /** Text profile: twitter is published to X only; default to every other network */
    profile: 'twitter' | 'default';
    /** The targeted networks this text is published to */
    platforms: string[];
    /** The text published to this profile's networks; null when the DeepSeek rewrite failed */
    content: null | string;
    /** content's length as the limit counts it: on X, CJK and emoji count as 2 and every link as 23 */
    length: number;
    /** This profile's text limit */
    maxLength: number;
    /** Model that wrote this variant */
    aiModel: null | string;
    /** Edited by hand after generation */
    edited: boolean;
  }[];
  /** Connected accounts the post publishes to */
  targets: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
    /** Per-account publish status */
    status: 'PENDING' | 'PUBLISHED' | 'FAILED' | 'DELETED';
    /** Live post URL once published */
    publishedUrl: null | string;
    /** Publish error reported by Zernio */
    error: null | string;
  }[];
  /** Attached images */
  media: {
    /** Media id */
    id: number;
    /** Object key in the (private) bucket */
    key: string;
    /** Short-lived signed read link for showing the image; fetch a fresh one by reading the post again */
    previewUrl: string;
    contentType: string;
    sizeBytes: number;
    /** Order on the post */
    position: number;
    /** Registered at */
    createdAt: string;
  }[];
  /** Created at */
  createdAt: string;
  createdBy: number;
  /** Updated at */
  updatedAt: string;
  updatedBy: number;
};
export type RedraftSocialPostResponse = {
  /** Social post id */
  id: number;
  /** The author's draft, as written */
  originalText: string;
  /** DRAFT → SCHEDULED → PUBLISHING → PUBLISHED | PARTIAL | FAILED; SCHEDULED → CANCELLED; SCHEDULED → DRAFT (unschedule); FAILED → DRAFT (redraft); PUBLISHED/PARTIAL → UNPUBLISHED (unpublish: taken down from every network). assistant-smm owns the whole lifecycle; Zernio only publishes. */
  status:
    | 'DRAFT'
    | 'SCHEDULED'
    | 'PUBLISHING'
    | 'PUBLISHED'
    | 'PARTIAL'
    | 'FAILED'
    | 'CANCELLED'
    | 'UNPUBLISHED';
  /** When the post publishes (UTC) */
  scheduledFor: null | string;
  /** IANA zone the time was chosen in */
  timezone: null | string;
  /** scheduledFor as wall-clock time in timezone (YYYY-MM-DDTHH:mm:ss) */
  scheduledAt: null | string;
  /** Zernio post id once published */
  zernioPostId: null | string;
  /** When it was published */
  publishedAt: null | string;
  /** Why the post failed or partially failed */
  failureReason: null | string;
  /** The text per profile the targets need: twitter for X, default for every other network */
  variants: {
    /** Text profile: twitter is published to X only; default to every other network */
    profile: 'twitter' | 'default';
    /** The targeted networks this text is published to */
    platforms: string[];
    /** The text published to this profile's networks; null when the DeepSeek rewrite failed */
    content: null | string;
    /** content's length as the limit counts it: on X, CJK and emoji count as 2 and every link as 23 */
    length: number;
    /** This profile's text limit */
    maxLength: number;
    /** Model that wrote this variant */
    aiModel: null | string;
    /** Edited by hand after generation */
    edited: boolean;
  }[];
  /** Connected accounts the post publishes to */
  targets: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
    /** Per-account publish status */
    status: 'PENDING' | 'PUBLISHED' | 'FAILED' | 'DELETED';
    /** Live post URL once published */
    publishedUrl: null | string;
    /** Publish error reported by Zernio */
    error: null | string;
  }[];
  /** Attached images */
  media: {
    /** Media id */
    id: number;
    /** Object key in the (private) bucket */
    key: string;
    /** Short-lived signed read link for showing the image; fetch a fresh one by reading the post again */
    previewUrl: string;
    contentType: string;
    sizeBytes: number;
    /** Order on the post */
    position: number;
    /** Registered at */
    createdAt: string;
  }[];
  /** Created at */
  createdAt: string;
  createdBy: number;
  /** Updated at */
  updatedAt: string;
  updatedBy: number;
};
export type UnpublishSocialPostResponse = {
  /** Social post id */
  id: number;
  /** The author's draft, as written */
  originalText: string;
  /** DRAFT → SCHEDULED → PUBLISHING → PUBLISHED | PARTIAL | FAILED; SCHEDULED → CANCELLED; SCHEDULED → DRAFT (unschedule); FAILED → DRAFT (redraft); PUBLISHED/PARTIAL → UNPUBLISHED (unpublish: taken down from every network). assistant-smm owns the whole lifecycle; Zernio only publishes. */
  status:
    | 'DRAFT'
    | 'SCHEDULED'
    | 'PUBLISHING'
    | 'PUBLISHED'
    | 'PARTIAL'
    | 'FAILED'
    | 'CANCELLED'
    | 'UNPUBLISHED';
  /** When the post publishes (UTC) */
  scheduledFor: null | string;
  /** IANA zone the time was chosen in */
  timezone: null | string;
  /** scheduledFor as wall-clock time in timezone (YYYY-MM-DDTHH:mm:ss) */
  scheduledAt: null | string;
  /** Zernio post id once published */
  zernioPostId: null | string;
  /** When it was published */
  publishedAt: null | string;
  /** Why the post failed or partially failed */
  failureReason: null | string;
  /** The text per profile the targets need: twitter for X, default for every other network */
  variants: {
    /** Text profile: twitter is published to X only; default to every other network */
    profile: 'twitter' | 'default';
    /** The targeted networks this text is published to */
    platforms: string[];
    /** The text published to this profile's networks; null when the DeepSeek rewrite failed */
    content: null | string;
    /** content's length as the limit counts it: on X, CJK and emoji count as 2 and every link as 23 */
    length: number;
    /** This profile's text limit */
    maxLength: number;
    /** Model that wrote this variant */
    aiModel: null | string;
    /** Edited by hand after generation */
    edited: boolean;
  }[];
  /** Connected accounts the post publishes to */
  targets: {
    /** Zernio platform id */
    platform: string;
    /** Zernio connected account id (from GET /admin/social-accounts) */
    accountId: string;
    /** Per-account publish status */
    status: 'PENDING' | 'PUBLISHED' | 'FAILED' | 'DELETED';
    /** Live post URL once published */
    publishedUrl: null | string;
    /** Publish error reported by Zernio */
    error: null | string;
  }[];
  /** Attached images */
  media: {
    /** Media id */
    id: number;
    /** Object key in the (private) bucket */
    key: string;
    /** Short-lived signed read link for showing the image; fetch a fresh one by reading the post again */
    previewUrl: string;
    contentType: string;
    sizeBytes: number;
    /** Order on the post */
    position: number;
    /** Registered at */
    createdAt: string;
  }[];
  /** Created at */
  createdAt: string;
  createdBy: number;
  /** Updated at */
  updatedAt: string;
  updatedBy: number;
};
export type PresignSocialPostMediaResponse = {
  /** POST the multipart form here */
  url: string;
  /** Form fields to send, in order, before the file field (named `file`) */
  fields: object;
  /** Object key the upload lands at; register it after uploading */
  key: string;
};
export type PresignSocialPostMediaBody = {
  /** One of: image/jpeg, image/png, image/gif, image/webp */
  contentType: 'image/jpeg' | 'image/png' | 'image/gif' | 'image/webp';
  /** Size of the file about to be uploaded */
  sizeBytes: number;
};
export type RegisterSocialPostMediaResponse = {
  /** Media id */
  id: number;
  /** Object key in the (private) bucket */
  key: string;
  /** Short-lived signed read link for showing the image; fetch a fresh one by reading the post again */
  previewUrl: string;
  contentType: string;
  sizeBytes: number;
  /** Order on the post */
  position: number;
  /** Registered at */
  createdAt: string;
};
export type RegisterSocialPostMediaBody = {
  /** The key returned by presign, after uploading to it */
  key: string;
};
export type ListSocialAccountsResponse = {
  /** Zernio account id; use as a target accountId */
  id: string;
  platform: string;
  /** Handle on the platform */
  username: null | string;
  /** Display name on the platform */
  displayName: null | string;
  /** Avatar URL */
  profilePicture: null | string;
  /** Connection is active */
  isActive: boolean;
  /** The platform revoked the token; reconnect in Zernio */
  needsReconnection: boolean;
}[];
